(function () {
  if (customElements.get('imoco-personalization')) return;
  var modes = {
    number: { label: 'Personalizzata - Solo numero', fee: 750, name: false, number: true },
    name: { label: 'Personalizzata - Solo nome', fee: 750, name: true, number: false },
    both: { label: 'Personalizzata - Nome e numero', aliases: ['Personalizzata - Nome + numero'], fee: 1500, name: true, number: true }
  };
  function modeKey(value) {
    var normalized = String(value || '').trim().toLowerCase().replace(/\s*\+\s*/g, ' e ').replace(/\s+/g, ' ');
    return Object.keys(modes).find(function(key) { return modes[key].label.toLowerCase() === normalized; });
  }
  class ImocoPersonalization extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.root = this.closest('.product__section');
      this.form = document.getElementById(this.dataset.form) || this.closest('form');
      if (!this.form) return;
      this.variants = JSON.parse(this.querySelector('[data-imoco-variants]').textContent);
      this.mode = this.querySelector('[data-imoco-mode]');
      this.nameInput = this.querySelector('[data-imoco-name]');
      this.numberInput = this.querySelector('[data-imoco-number]');
      this.message = this.querySelector('[data-imoco-message]');
      this.mode.addEventListener('change', () => this.selectMode());
      [this.nameInput, this.numberInput].forEach(input => input.addEventListener('input', () => this.updatePreview()));
      this.root.addEventListener('change', (event) => {
        if (!this.contains(event.target)) {
          [0, 100, 350].forEach(delay => setTimeout(() => this.update(), delay));
        }
      });
      this.form.addEventListener('submit', (event) => {
        this.update();
        if (this.hidden || this.player) return;
        if (!this.valid || !this.nameInput.checkValidity() || !this.numberInput.checkValidity()) {
          event.preventDefault(); event.stopImmediatePropagation();
          this.form.reportValidity();
          if (!this.valid) this.message.textContent = 'Questa personalizzazione non è ancora disponibile. Scegli un’altra configurazione.';
        }
      }, true);
      var removeLegacyField = () => {
        var appChoice = this.root.querySelector('#bcpo select[data-option="option2"]');
        var appRow = appChoice && appChoice.closest('.selector-wrapper');
        if (appRow && appRow.nextElementSibling !== this) appRow.insertAdjacentElement('afterend', this);
        this.root.querySelectorAll('#bcpo input[name="properties[Inserisci qui il nome e il numero (per maglia personalizzata)]"]').forEach(input => {
          var wrapper = input.closest('.selector-wrapper');
          if (wrapper && !wrapper.hidden) wrapper.hidden = true;
          if (!input.disabled) input.disabled = true;
          if (input.required) input.required = false;
          if (input.value) input.value = '';
        });
      };
      this.legacyObserver = new MutationObserver(removeLegacyField);
      this.legacyObserver.observe(this.root, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'required', 'hidden']});
      removeLegacyField();
      this.update();
      if (document.fonts) document.fonts.load('400 60px "Imoco Sporten"').then(() => { if (this.isConnected) this.updatePreview(); });
    }
    disconnectedCallback() {
      setTimeout(() => { if (!this.isConnected && this.legacyObserver) this.legacyObserver.disconnect(); }, 0);
    }
    updatePreview(){
 var preview=this.querySelector('[data-imoco-preview]');if(!preview)return;
 var name=this.player?this.player.name:(this.nameInput.disabled?'':this.nameInput.value.trim().toUpperCase());
 var number=this.player?this.player.number:(this.numberInput.disabled?'':this.numberInput.value.replace(/[^0-9]/g,'').slice(0,2));
 this.nameInput.setCustomValidity(!this.nameInput.disabled&&this.nameInput.value&&!name?'Inserisci un nome valido.':'');
 var n=preview.querySelector('[data-imoco-preview-name]'),t=preview.querySelector('[data-imoco-preview-number]');
 n.textContent=name;t.textContent=number;
 this.fitPreviewText(n,60,360);this.fitPreviewText(t,210,160);
 preview.querySelector('[data-imoco-preview-description]').textContent='Anteprima del retro'+(name?', nome: '+name:'')+(number?', numero: '+number:'');
}
fitPreviewText(node,size,maxWidth){
 node.removeAttribute('textLength');node.removeAttribute('lengthAdjust');node.style.fontSize=size+'px';
 var width=node.getComputedTextLength();
 if(Number.isFinite(width)&&width>maxWidth)node.style.fontSize=(size*maxWidth/width)+'px';
}
    current() {
      var id = this.form.querySelector('[name="id"]').value;
      return this.variants.find(v => String(v.id) === id);
    }
    target(mode) {
      var current = this.current();
      if (!current || !mode) return null;
      var base = this.variants.find(v => v.option1 === current.option1 && v.option2 === 'Neutra');
      if (!base) return null;
      return this.variants.find(v => v.option1 === current.option1 && (v.option2 === mode.label || (mode.aliases || []).includes(v.option2)) && v.price === base.price + mode.fee && v.available);
    }
    selectMode() {
      var target = this.target(modes[this.mode.value]);
      if (target) {
        var select = this.root.querySelector('select[name="options[Giocatrice]"]');
        if (select) { select.value = target.option2; select.dispatchEvent(new Event('change', {bubbles:true})); }
        else {
          var radio = Array.from(this.root.querySelectorAll('.swatches__container[data-option-index="2"] input')).find(x => x.value === target.option2);
          if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', {bubbles:true})); }
        }
      }
      setTimeout(() => this.update(), 0);
    }
    update() {
      var current = this.current();
      var value = current && current.option2 || '';
      var appChoice = this.root.querySelector('#bcpo select[data-option="option2"]');
      // Bold updates its visible choice before synchronizing the Shopify variant ID.
      if (appChoice) value = appChoice.value;
      var playerChoice = String(value).trim().match(/^(\d{1,2})\s*[-–—]\s*(.+)$/);
      this.player = playerChoice && this.querySelector('[data-imoco-preview]') ? {name:playerChoice[2].trim().toUpperCase(), number:playerChoice[1]} : null;
      this.hidden = !this.player && !/^Personalizzata/i.test(value);
      var legend = this.querySelector('[data-imoco-legend]');
      if (legend) legend.textContent = this.player ? 'La tua maglia' : 'La tua personalizzazione';
      var selectedKey = modeKey(value);
      this.mode.value = selectedKey || '';
      this.lastVariantId = current && current.id;
      var mode = this.hidden || this.player ? null : modes[this.mode.value];
      this.valid = this.player ? !!(current && current.option2 === value) : !!(mode && this.target(mode) && this.target(mode).id === current.id);
      [[this.nameInput, 'name'], [this.numberInput, 'number']].forEach(([input, key]) => {
        var enabled = !!(mode && mode[key] && !this.hidden);
        input.disabled = !enabled; input.required = enabled;
        this.querySelector('[data-imoco-' + key + '-row]').hidden = !enabled;
        // Keep typed values during asynchronous variant updates; disabled fields are not submitted.
      });
      var property = this.querySelector('[data-imoco-property]');
      property.disabled = this.hidden || !!this.player || !this.valid;
      property.value = mode ? mode.label.replace('Personalizzata - ', '') : '';
      var choice = this.querySelector('[data-imoco-choice]');
      if (choice) choice.textContent = this.player ? this.player.name + ' · Numero ' + this.player.number : mode ? mode.label.replace('Personalizzata - ', '') + (mode.fee === 1500 ? ' · +€15,00' : ' · +€7,50') : 'Scegli Solo nome, Solo numero oppure Nome e numero nell’opzione Giocatrice.';
      this.message.textContent = this.player ? 'La maglia scelta viene stampata con il nome e il numero della giocatrice.' : this.hidden ? '' : this.valid ? 'Il prezzo della variante include la stampa scelta.' : 'Questa personalizzazione non è ancora disponibile per la taglia scelta.';
      var payment = this.form.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = !this.hidden && !this.player;
      this.updatePreview();
    }
  }
  customElements.define('imoco-personalization', ImocoPersonalization);
}());
